import React from 'react';
import { Sparkles, Headset, FolderOpen } from 'lucide-react';
import { OnboardingChecklist } from './OnboardingChecklist';
export function WelcomeBackPromo() {
  const features = [{
    icon: Sparkles,
    title: 'LawVo AI',
    description: 'Get instant answers to legal questions with our AI-powered assistant.',
    color: 'bg-aliceBlue text-violetBlue'
  }, {
    icon: Headset,
    title: '24/7 Legal Help',
    description: 'Connect with legal experts anytime for professional advice.',
    color: 'bg-aliceBlue text-turquoise'
  }, {
    icon: FolderOpen,
    title: 'Document Hub',
    description: 'Securely store, organize, and review your important legal documents.',
    color: 'bg-aliceBlue text-violetBlue'
  }];
  return <div className="mb-6 px-3 sm:px-6" data-id="element-485">
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-6" data-id="element-486">
        <h2 className="text-xl sm:text-2xl font-semibold text-primary" data-id="element-487">
          Welcome back, Sarah
        </h2>

        <OnboardingChecklist data-id="element-488" />
      </div>
    </div>;
}